module.exports = __webpack_public_path__ + "public/images/calendar-checkmark.6ea9d626527a5c6b1aefb83176a5376b.png";